import React from "react";

export const VendorStaffDetailContext = React.createContext(null);

export const useVendorStaffDetailContext = () => {
  const context = React.useContext(VendorStaffDetailContext);

  if (!context) throw new Error("Vendor Staff Detail Context not provided!");

  return context;
};
